import {UnstyledButton} from "@mantine/core";
import IconX from "../../../assets/x.svg?react";
import classes from "./PreviewCloseButton.module.css";

type Props = {
    label: string;
    onClick: () => void;
};

/** The close control shared by every preview box kind: a bare X in the top right corner,
 *  no background, darker on hover and focus. */
export const PreviewCloseButton = ({label, onClick}: Props) => (
    <UnstyledButton
        type="button"
        className={classes.close}
        onClick={onClick}
        aria-label={label}
    >
        <IconX width={14} height={14} aria-hidden="true" />
    </UnstyledButton>
);
